import { LucideIcon } from 'lucide-react';
import {
  LayoutDashboard,
  FolderOpen,
  Users,
  ClipboardList,
  Calendar,
  Receipt,
  Wrench,
  Package,
  Building2,
  ShieldCheck,
} from 'lucide-react';
import { featureConfig } from 'config/features';

export interface TourBulletPoint {
  textKey: string;
}

export interface TourSection {
  id: string;
  nameKey: string;
  icon: LucideIcon;
  titleKey: string;
  subtitleKey: string;
  descriptionKey: string;
  bullets: TourBulletPoint[];
  videoUrl?: string | null;
  featureFlag?: keyof typeof featureConfig;
}

export const TOUR_SECTIONS: TourSection[] = [
  {
    id: 'dashboard',
    nameKey: 'TOUR_SECTION_DASHBOARD',
    icon: LayoutDashboard,
    titleKey: 'TOUR_DASHBOARD_TITLE',
    subtitleKey: 'TOUR_DASHBOARD_SUBTITLE',
    descriptionKey: 'TOUR_DASHBOARD_DESCRIPTION',
    bullets: [
      { textKey: 'TOUR_DASHBOARD_BULLET_1' },
      { textKey: 'TOUR_DASHBOARD_BULLET_2' },
      { textKey: 'TOUR_DASHBOARD_BULLET_3' },
      { textKey: 'TOUR_DASHBOARD_BULLET_4' },
    ],
    videoUrl: null,
    featureFlag: 'dashboard',
  },
  {
    id: 'projects',
    nameKey: 'TOUR_SECTION_PROJECTS',
    icon: FolderOpen,
    titleKey: 'TOUR_PROJECTS_TITLE',
    subtitleKey: 'TOUR_PROJECTS_SUBTITLE',
    descriptionKey: 'TOUR_PROJECTS_DESCRIPTION',
    bullets: [
      { textKey: 'TOUR_PROJECTS_BULLET_1' },
      { textKey: 'TOUR_PROJECTS_BULLET_2' },
      { textKey: 'TOUR_PROJECTS_BULLET_3' },
      { textKey: 'TOUR_PROJECTS_BULLET_4' },
    ],
    videoUrl: null,
    featureFlag: 'projects',
  },
  {
    id: 'leads',
    nameKey: 'TOUR_SECTION_LEADS',
    icon: Users,
    titleKey: 'TOUR_LEADS_TITLE',
    subtitleKey: 'TOUR_LEADS_SUBTITLE',
    descriptionKey: 'TOUR_LEADS_DESCRIPTION',
    bullets: [
      { textKey: 'TOUR_LEADS_BULLET_1' },
      { textKey: 'TOUR_LEADS_BULLET_2' },
      { textKey: 'TOUR_LEADS_BULLET_3' },
      { textKey: 'TOUR_LEADS_BULLET_4' },
    ],
    videoUrl: null,
    featureFlag: 'leads',
  },
  {
    id: 'tasks',
    nameKey: 'TOUR_SECTION_TASKS',
    icon: ClipboardList,
    titleKey: 'TOUR_TASKS_TITLE',
    subtitleKey: 'TOUR_TASKS_SUBTITLE',
    descriptionKey: 'TOUR_TASKS_DESCRIPTION',
    bullets: [
      { textKey: 'TOUR_TASKS_BULLET_1' },
      { textKey: 'TOUR_TASKS_BULLET_2' },
      { textKey: 'TOUR_TASKS_BULLET_3' },
      { textKey: 'TOUR_TASKS_BULLET_4' },
    ],
    videoUrl: null,
    featureFlag: 'tasks',
  },
  {
    id: 'schedule',
    nameKey: 'TOUR_SECTION_SCHEDULE',
    icon: Calendar,
    titleKey: 'TOUR_SCHEDULE_TITLE',
    subtitleKey: 'TOUR_SCHEDULE_SUBTITLE',
    descriptionKey: 'TOUR_SCHEDULE_DESCRIPTION',
    bullets: [
      { textKey: 'TOUR_SCHEDULE_BULLET_1' },
      { textKey: 'TOUR_SCHEDULE_BULLET_2' },
      { textKey: 'TOUR_SCHEDULE_BULLET_3' },
      { textKey: 'TOUR_SCHEDULE_BULLET_4' },
    ],
    videoUrl: null,
    featureFlag: 'schedule',
  },
  {
    id: 'accounting',
    nameKey: 'TOUR_SECTION_ACCOUNTING',
    icon: Receipt,
    titleKey: 'TOUR_ACCOUNTING_TITLE',
    subtitleKey: 'TOUR_ACCOUNTING_SUBTITLE',
    descriptionKey: 'TOUR_ACCOUNTING_DESCRIPTION',
    bullets: [
      { textKey: 'TOUR_ACCOUNTING_BULLET_1' },
      { textKey: 'TOUR_ACCOUNTING_BULLET_2' },
      { textKey: 'TOUR_ACCOUNTING_BULLET_3' },
      { textKey: 'TOUR_ACCOUNTING_BULLET_4' },
    ],
    videoUrl: null,
    featureFlag: 'accounting',
  },
  {
    id: 'work-orders',
    nameKey: 'TOUR_SECTION_WORK_ORDERS',
    icon: Wrench,
    titleKey: 'TOUR_WORK_ORDERS_TITLE',
    subtitleKey: 'TOUR_WORK_ORDERS_SUBTITLE',
    descriptionKey: 'TOUR_WORK_ORDERS_DESCRIPTION',
    bullets: [
      { textKey: 'TOUR_WORK_ORDERS_BULLET_1' },
      { textKey: 'TOUR_WORK_ORDERS_BULLET_2' },
      { textKey: 'TOUR_WORK_ORDERS_BULLET_3' },
      { textKey: 'TOUR_WORK_ORDERS_BULLET_4' },
    ],
    videoUrl: null,
    featureFlag: 'workOrders',
  },
  {
    id: 'inventory',
    nameKey: 'TOUR_SECTION_INVENTORY',
    icon: Package,
    titleKey: 'TOUR_INVENTORY_TITLE',
    subtitleKey: 'TOUR_INVENTORY_SUBTITLE',
    descriptionKey: 'TOUR_INVENTORY_DESCRIPTION',
    bullets: [
      { textKey: 'TOUR_INVENTORY_BULLET_1' },
      { textKey: 'TOUR_INVENTORY_BULLET_2' },
      { textKey: 'TOUR_INVENTORY_BULLET_3' },
      { textKey: 'TOUR_INVENTORY_BULLET_4' },
    ],
    videoUrl: null,
    featureFlag: 'inventory',
  },
  {
    id: 'company',
    nameKey: 'TOUR_SECTION_SETTINGS',
    icon: Building2,
    titleKey: 'TOUR_SETTINGS_TITLE',
    subtitleKey: 'TOUR_SETTINGS_SUBTITLE',
    descriptionKey: 'TOUR_SETTINGS_DESCRIPTION',
    bullets: [
      { textKey: 'TOUR_SETTINGS_BULLET_1' },
      { textKey: 'TOUR_SETTINGS_BULLET_2' },
      { textKey: 'TOUR_SETTINGS_BULLET_3' },
      { textKey: 'TOUR_SETTINGS_BULLET_4' },
    ],
    videoUrl: null,
    featureFlag: 'team',
  },
  {
    id: 'admin-roles',
    nameKey: 'TOUR_SECTION_ADMIN_ROLES',
    icon: ShieldCheck,
    titleKey: 'TOUR_ADMIN_ROLES_TITLE',
    subtitleKey: 'TOUR_ADMIN_ROLES_SUBTITLE',
    descriptionKey: 'TOUR_ADMIN_ROLES_DESCRIPTION',
    bullets: [
      { textKey: 'TOUR_ADMIN_ROLES_BULLET_1' },
      { textKey: 'TOUR_ADMIN_ROLES_BULLET_2' },
      { textKey: 'TOUR_ADMIN_ROLES_BULLET_3' },
      { textKey: 'TOUR_ADMIN_ROLES_BULLET_4' },
    ],
    videoUrl: null,
  },
];

/**
 * Returns only the tour sections whose feature flags are enabled.
 * Sections without a featureFlag are always included.
 */
export const getEnabledTourSections = (): TourSection[] => {
  return TOUR_SECTIONS.filter((section) => {
    if (!section.featureFlag) return true;
    return featureConfig[section.featureFlag];
  });
};
